exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-chip .v-chip__content{cursor:pointer}", ""]);

// exports
